import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createTextVNode as _createTextVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, vModelRadio as _vModelRadio, vModelSelect as _vModelSelect, mergeProps as _mergeProps, vModelCheckbox as _vModelCheckbox, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-00cecbb3"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "w-full"
}
const _hoisted_2 = { class: "flex flex-wrap justify-center pt-2 w-full" }
const _hoisted_3 = {
  class: "w-full mt-2",
  "data-cy": "person-details-user-info",
  ref: "personal-info-section"
}
const _hoisted_4 = {
  key: 0,
  class: "w-full pt-2",
  "data-cy": "firstName"
}
const _hoisted_5 = { class: "block text-gray-600 text-sm font-bold mb-2" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "text-red-500",
  "data-cy": "mandatory"
}, "*", -1))
const _hoisted_7 = { class: "flex w-full" }
const _hoisted_8 = ["disabled"]
const _hoisted_9 = {
  key: 0,
  class: "text-red-600 text-xs italic mt-1 pb-1",
  "data-cy": "error"
}
const _hoisted_10 = {
  key: 1,
  class: "w-full pt-2",
  "data-cy": "lastName"
}
const _hoisted_11 = { class: "block text-gray-600 text-sm font-bold mb-2" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "text-red-500",
  "data-cy": "mandatory"
}, "*", -1))
const _hoisted_13 = { class: "flex w-full" }
const _hoisted_14 = ["disabled"]
const _hoisted_15 = {
  key: 0,
  class: "text-red-600 text-xs italic mt-1 pb-1",
  "data-cy": "error"
}
const _hoisted_16 = {
  key: 2,
  class: "w-full pt-2",
  "data-cy": "ssn"
}
const _hoisted_17 = { class: "block text-gray-600 text-sm font-bold mb-2" }
const _hoisted_18 = {
  key: 0,
  class: "text-red-500",
  "data-cy": "mandatory"
}
const _hoisted_19 = { class: "flex w-full" }
const _hoisted_20 = ["disabled"]
const _hoisted_21 = {
  key: 0,
  class: "text-red-600 text-xs italic mt-1 pb-1",
  "data-cy": "error"
}
const _hoisted_22 = {
  key: 3,
  class: "w-full pt-2",
  "data-cy": "salutation"
}
const _hoisted_23 = { class: "block text-gray-600 text-sm font-bold mb-2" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "text-red-500",
  "data-cy": "mandatory"
}, "*", -1))
const _hoisted_25 = { class: "flex w-full justify-between" }
const _hoisted_26 = ["data-cy"]
const _hoisted_27 = ["value", "onUpdate:modelValue", "disabled"]
const _hoisted_28 = { class: "ml-2" }
const _hoisted_29 = {
  key: 0,
  class: "text-red-600 text-xs italic mt-1",
  "data-cy": "error"
}
const _hoisted_30 = {
  key: 4,
  class: "w-full pt-2",
  "data-cy": "gender"
}
const _hoisted_31 = { class: "block text-gray-600 text-sm font-bold mb-2" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "text-red-500",
  "data-cy": "mandatory"
}, "*", -1))
const _hoisted_33 = { class: "flex w-full" }
const _hoisted_34 = ["data-cy"]
const _hoisted_35 = ["checked", "value", "disabled", "onUpdate:modelValue"]
const _hoisted_36 = { class: "ml-2" }
const _hoisted_37 = {
  key: 0,
  class: "text-red-600 text-xs italic mt-1",
  "data-cy": "error"
}
const _hoisted_38 = {
  key: 5,
  class: "w-full pt-2",
  "data-cy": "birthday"
}
const _hoisted_39 = { class: "block text-gray-600 text-sm font-bold mb-2" }
const _hoisted_40 = {
  key: 0,
  class: "text-red-500",
  "data-cy": "mandatory"
}
const _hoisted_41 = { class: "flex w-full" }
const _hoisted_42 = ["max", "disabled", "dir"]
const _hoisted_43 = {
  key: 0,
  class: "text-red-600 text-xs italic mt-1 pb-1",
  "data-cy": "error"
}
const _hoisted_44 = {
  key: 6,
  class: "w-full pt-2",
  "data-cy": "language"
}
const _hoisted_45 = { class: "block text-gray-600 text-sm font-bold mb-2" }
const _hoisted_46 = {
  key: 0,
  class: "text-red-500",
  "data-cy": "mandatory"
}
const _hoisted_47 = { class: "flex w-full" }
const _hoisted_48 = ["disabled"]
const _hoisted_49 = {
  disabled: "",
  selected: "",
  value: undefined
}
const _hoisted_50 = ["value"]
const _hoisted_51 = {
  key: 0,
  class: "text-red-600 text-xs italic mt-1",
  "data-cy": "error"
}
const _hoisted_52 = {
  key: 7,
  class: "w-full pt-2",
  "data-cy": "phone"
}
const _hoisted_53 = { class: "block text-gray-600 text-sm font-bold mb-2" }
const _hoisted_54 = {
  key: 0,
  class: "text-red-500",
  "data-cy": "mandatory"
}
const _hoisted_55 = { class: "flex w-full" }
const _hoisted_56 = {
  key: 0,
  class: "text-red-600 text-xs italic mt-1",
  "data-cy": "error"
}
const _hoisted_57 = {
  key: 8,
  class: "w-full pt-2",
  "data-cy": "userId_block"
}
const _hoisted_58 = {
  key: 0,
  "data-cy": "new_user_mode"
}
const _hoisted_59 = { class: "flex w-full" }
const _hoisted_60 = { class: "block text-gray-600 text-sm font-bold mb-2 w-1/3" }
const _hoisted_61 = {
  key: 0,
  class: "text-red-500",
  "data-cy": "mandatory"
}
const _hoisted_62 = { class: "block text-gray-600 text-sm font-bold mb-2 w-full ml-2" }
const _hoisted_63 = {
  key: 0,
  class: "text-red-500",
  "data-cy": "mandatory"
}
const _hoisted_64 = { class: "flex w-full" }
const _hoisted_65 = {
  value: undefined,
  disabled: "",
  selected: ""
}
const _hoisted_66 = {
  key: 0,
  value: 'passport',
  "data-cy": "passport-option"
}
const _hoisted_67 = {
  key: 1,
  value: 'nationalId',
  "data-cy": "nationalId-option"
}
const _hoisted_68 = {
  key: 2,
  value: 'residentId',
  "data-cy": "residentId-option"
}
const _hoisted_69 = {
  key: 1,
  "data-cy": "existing_user_mode"
}
const _hoisted_70 = {
  key: 0,
  "data-cy": "national-id"
}
const _hoisted_71 = { class: "block text-gray-600 text-sm font-bold mb-2" }
const _hoisted_72 = ["disabled"]
const _hoisted_73 = {
  key: 1,
  "data-cy": "resident-id"
}
const _hoisted_74 = { class: "block text-gray-600 text-sm font-bold mb-2" }
const _hoisted_75 = ["disabled"]
const _hoisted_76 = {
  key: 2,
  "data-cy": "passport"
}
const _hoisted_77 = { class: "block text-gray-600 text-sm font-bold mb-2" }
const _hoisted_78 = ["disabled"]
const _hoisted_79 = {
  key: 9,
  class: "w-full pt-2",
  "data-cy": "passport-block"
}
const _hoisted_80 = { class: "flex w-full" }
const _hoisted_81 = { class: "block text-gray-600 text-sm font-bold mb-2 w-1/2" }
const _hoisted_82 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "text-red-500",
  "data-cy": "mandatory"
}, "*", -1))
const _hoisted_83 = { class: "block text-gray-600 text-sm font-bold mb-2 w-1/2 ml-2" }
const _hoisted_84 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "text-red-500",
  "data-cy": "mandatory"
}, "*", -1))
const _hoisted_85 = {
  class: "flex w-full",
  "data-cy": "passportCountryAndExpirationDate"
}
const _hoisted_86 = ["disabled"]
const _hoisted_87 = {
  disabled: "",
  selected: "",
  value: undefined
}
const _hoisted_88 = ["value"]
const _hoisted_89 = ["disabled", "min"]
const _hoisted_90 = {
  key: 10,
  class: "text-red-600 text-xs italic mt-1",
  "data-cy": "id-error"
}
const _hoisted_91 = { class: "flex flex-wrap justify-center pt-2 w-full" }
const _hoisted_92 = {
  class: "w-full mt-2",
  "data-cy": "person-details-address-info",
  ref: "address-section"
}
const _hoisted_93 = {
  key: 0,
  class: "w-full pt-2",
  "data-cy": "address1"
}
const _hoisted_94 = {
  class: "block text-gray-600 text-sm font-bold mb-2",
  "data-cy": "address-label"
}
const _hoisted_95 = {
  key: 0,
  class: "text-red-500",
  "data-cy": "mandatory"
}
const _hoisted_96 = { class: "flex w-full" }
const _hoisted_97 = ["disabled"]
const _hoisted_98 = {
  key: 0,
  class: "text-red-600 text-xs italic mt-1 pb-1",
  "data-cy": "error"
}
const _hoisted_99 = {
  key: 1,
  class: "w-full pt-2",
  "data-cy": "address2"
}
const _hoisted_100 = { class: "block text-gray-600 text-sm font-bold mb-2" }
const _hoisted_101 = {
  key: 0,
  class: "text-red-500",
  "data-cy": "mandatory"
}
const _hoisted_102 = { class: "flex w-full" }
const _hoisted_103 = ["disabled"]
const _hoisted_104 = {
  key: 0,
  class: "text-red-600 text-xs italic mt-1 pb-1",
  "data-cy": "error"
}
const _hoisted_105 = {
  key: 2,
  class: "w-full pt-2",
  "data-cy": "country"
}
const _hoisted_106 = { class: "block text-gray-600 text-sm font-bold mb-2" }
const _hoisted_107 = {
  key: 0,
  class: "text-red-500",
  "data-cy": "mandatory"
}
const _hoisted_108 = { class: "flex w-full" }
const _hoisted_109 = ["disabled"]
const _hoisted_110 = {
  disabled: "",
  selected: "",
  value: undefined
}
const _hoisted_111 = ["value"]
const _hoisted_112 = {
  key: 0,
  class: "text-red-600 text-xs italic mt-1",
  "data-cy": "error"
}
const _hoisted_113 = {
  key: 3,
  class: "w-full pt-2",
  "data-cy": "zipCode"
}
const _hoisted_114 = { class: "block text-gray-600 text-sm font-bold mb-2" }
const _hoisted_115 = {
  key: 0,
  class: "text-red-500",
  "data-cy": "mandatory"
}
const _hoisted_116 = { class: "flex w-full" }
const _hoisted_117 = ["disabled", "placeholder"]
const _hoisted_118 = {
  key: 0,
  class: "text-red-600 text-xs italic mt-1 pb-1",
  "data-cy": "error"
}
const _hoisted_119 = {
  key: 4,
  class: "w-full pt-2",
  "data-cy": "city"
}
const _hoisted_120 = { class: "block text-gray-600 text-sm font-bold mb-2" }
const _hoisted_121 = {
  key: 0,
  class: "text-red-500",
  "data-cy": "mandatory"
}
const _hoisted_122 = {
  key: 0,
  class: "flex w-full"
}
const _hoisted_123 = ["disabled"]
const _hoisted_124 = {
  key: 1,
  class: "flex w-full"
}
const _hoisted_125 = ["disabled"]
const _hoisted_126 = {
  disabled: "",
  selected: "",
  value: undefined
}
const _hoisted_127 = ["value"]
const _hoisted_128 = {
  key: 2,
  class: "text-red-600 text-xs italic mt-1",
  "data-cy": "error"
}
const _hoisted_129 = {
  key: 3,
  class: "flex text-xs italic mt-1",
  "data-cy": "checking"
}
const _hoisted_130 = {
  key: 5,
  class: "w-full pt-2",
  "data-cy": "state"
}
const _hoisted_131 = { class: "block text-gray-600 text-sm font-bold mb-2" }
const _hoisted_132 = {
  key: 0,
  class: "text-red-500",
  "data-cy": "mandatory"
}
const _hoisted_133 = { class: "flex w-full" }
const _hoisted_134 = ["disabled"]
const _hoisted_135 = {
  disabled: "",
  selected: "",
  value: undefined
}
const _hoisted_136 = ["value"]
const _hoisted_137 = {
  key: 0,
  class: "text-red-600 text-xs italic mt-1",
  "data-cy": "error"
}
const _hoisted_138 = {
  key: 0,
  class: "w-full mt-2",
  "data-cy": "person-details-contract",
  ref: "contract-section"
}
const _hoisted_139 = {
  key: 0,
  class: "w-full pt-2 pb-2",
  "data-cy": "htmlContract"
}
const _hoisted_140 = { class: "block text-gray-600 text-sm font-bold mb-2" }
const _hoisted_141 = { class: "flex w-full" }
const _hoisted_142 = {
  key: 1,
  class: "w-full pt-2 pb-2",
  "data-cy": "terms"
}
const _hoisted_143 = { class: "flex w-full" }
const _hoisted_144 = { class: "inline-flex items-center" }
const _hoisted_145 = {
  class: "ml-2",
  "data-cy": "text"
}
const _hoisted_146 = ["href"]
const _hoisted_147 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "text-red-500",
  "data-cy": "mandatory"
}, "*", -1))
const _hoisted_148 = {
  key: 0,
  class: "text-red-600 text-xs italic mt-1",
  "data-cy": "error"
}
const _hoisted_149 = {
  key: 2,
  class: "w-full pt-2 pb-2",
  "data-cy": "checkbox1"
}
const _hoisted_150 = { class: "flex w-full" }
const _hoisted_151 = { class: "inline-flex items-center" }
const _hoisted_152 = {
  class: "ml-2 flex flex-1 checkbox-text",
  "data-cy": "text"
}
const _hoisted_153 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "flex text-red-500",
  "data-cy": "mandatory"
}, "*", -1))
const _hoisted_154 = {
  key: 0,
  class: "text-red-600 text-xs italic mt-1",
  "data-cy": "error"
}
const _hoisted_155 = {
  key: 3,
  class: "w-full pt-2 pb-2",
  "data-cy": "checkbox2"
}
const _hoisted_156 = { class: "flex w-full" }
const _hoisted_157 = { class: "inline-flex items-center" }
const _hoisted_158 = {
  class: "ml-2 flex flex-1 checkbox-text",
  "data-cy": "text"
}
const _hoisted_159 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "flex text-red-500",
  "data-cy": "mandatory"
}, "*", -1))
const _hoisted_160 = {
  key: 0,
  class: "text-red-600 text-xs italic mt-1",
  "data-cy": "error"
}
const _hoisted_161 = {
  key: 4,
  class: "w-full pt-2 pb-2",
  "data-cy": "checkbox3"
}
const _hoisted_162 = { class: "flex w-full" }
const _hoisted_163 = { class: "inline-flex items-center" }
const _hoisted_164 = {
  class: "ml-2 flex flex-1 checkbox-text",
  "data-cy": "text"
}
const _hoisted_165 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "flex text-red-500",
  "data-cy": "mandatory"
}, "*", -1))
const _hoisted_166 = {
  key: 0,
  class: "text-red-600 text-xs italic mt-1",
  "data-cy": "error"
}
const _hoisted_167 = {
  class: "w-full mt-2",
  "data-cy": "person-details-user-misc",
  ref: "misc-section"
}
const _hoisted_168 = {
  key: 0,
  class: "w-full pt-2 pb-2",
  "data-cy": "allowEmailNewsletters"
}
const _hoisted_169 = { class: "flex w-full" }
const _hoisted_170 = { class: "inline-flex items-center" }
const _hoisted_171 = ["disabled"]
const _hoisted_172 = {
  class: "ml-2 checkbox-text",
  "data-cy": "text"
}
const _hoisted_173 = {
  key: 1,
  class: "w-full pt-2 pb-2",
  "data-cy": "allowThirdPartyOffers"
}
const _hoisted_174 = { class: "flex w-full" }
const _hoisted_175 = { class: "inline-flex items-center" }
const _hoisted_176 = ["disabled"]
const _hoisted_177 = {
  class: "ml-2 checkbox-text",
  "data-cy": "text"
}
const _hoisted_178 = {
  key: 2,
  class: "w-full pt-2 pb-2",
  "data-cy": "braze"
}
const _hoisted_179 = { class: "flex" }
const _hoisted_180 = ["disabled"]
const _hoisted_181 = { class: "" }
const _hoisted_182 = {
  key: 0,
  class: "w-full flex"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_error_display = _resolveComponent("error-display")!
  const _component_vue_tel_input = _resolveComponent("vue-tel-input")!
  const _component_spinner = _resolveComponent("spinner")!
  const _component_html_textarea = _resolveComponent("html-textarea")!

  return (_ctx.globalError)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_error_display, {
          "error-model": _ctx.globalError,
          "data-cy": "member-details-error"
        }, null, 8, ["error-model"])
      ]))
    : (_ctx.formConfig && _ctx.formConfig.systemPropertyConfig && _ctx.formConfig.mode)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: _normalizeClass([{
      'pt-2 md:grid md:grid-cols-2 md:gap-10 md:w-full sm:flex sm:flex-wrap sm:justify-center sm:w-full': _ctx.formConfig.mode === 'PROFILE',
    }, "flex flex-wrap justify-center pt-2 w-full pb-3"]),
          "data-cy": "member-form-block"
        }, [
          _withDirectives(_createElementVNode("div", _hoisted_2, [
            _withDirectives(_createElementVNode("h3", { class: "text-lg leading-6 font-medium text-gray-900 mt-2" }, _toDisplayString(_ctx.$t('subscription.personalInfoSection')), 513), [
              [_vShow, _ctx.theContainerHasChildren('personal-info-section')]
            ]),
            _createElementVNode("section", _hoisted_3, [
              (_ctx.shouldBeVisible(_ctx.formConfig.systemPropertyConfig.firstName, _ctx.formElements.firstName))
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                    _createElementVNode("label", _hoisted_5, [
                      _createTextVNode(_toDisplayString(_ctx.$t('subscription.firstName')) + " ", 1),
                      _hoisted_6
                    ]),
                    _createElementVNode("div", _hoisted_7, [
                      _withDirectives(_createElementVNode("input", {
                        name: "firstName",
                        type: "text",
                        class: _normalizeClass(["flex-grow join-input-field", { 'border-red-600': _ctx.formElements.firstName.error }]),
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formElements.firstName.value) = $event)),
                        onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.checkInput('firstName'))),
                        disabled: _ctx.formConfig.viewMode === 'VIEW' || _ctx.formConfig.systemPropertyConfig.firstName === 'view',
                        "data-cy": "input"
                      }, null, 42, _hoisted_8), [
                        [_vModelText, _ctx.formElements.firstName.value]
                      ])
                    ]),
                    (_ctx.formElements.firstName.error)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_9, _toDisplayString(_ctx.$t(_ctx.formElements.firstName.error)), 1))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.shouldBeVisible(_ctx.formConfig.systemPropertyConfig.lastName, _ctx.formElements.lastName))
                ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                    _createElementVNode("label", _hoisted_11, [
                      _createTextVNode(_toDisplayString(_ctx.$t('subscription.lastName')) + " ", 1),
                      _hoisted_12
                    ]),
                    _createElementVNode("div", _hoisted_13, [
                      _withDirectives(_createElementVNode("input", {
                        name: "lastName",
                        type: "text",
                        class: _normalizeClass(["flex-grow join-input-field", { 'border-red-600': _ctx.formElements.lastName.error }]),
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formElements.lastName.value) = $event)),
                        onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.checkInput('lastName'))),
                        disabled: _ctx.formConfig.viewMode === 'VIEW' || _ctx.formConfig.systemPropertyConfig.lastName === 'view',
                        "data-cy": "input"
                      }, null, 42, _hoisted_14), [
                        [_vModelText, _ctx.formElements.lastName.value]
                      ])
                    ]),
                    (_ctx.formElements.lastName.error)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_15, _toDisplayString(_ctx.$t(_ctx.formElements.lastName.error)), 1))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.shouldBeVisible(_ctx.formConfig.systemPropertyConfig.ssn, _ctx.formElements.ssn))
                ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                    _createElementVNode("label", _hoisted_17, [
                      _createTextVNode(_toDisplayString(_ctx.$t('subscription.ssn')) + " ", 1),
                      (_ctx.formConfig.systemPropertyConfig.ssn === 'required')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_18, "*"))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_19, [
                      _withDirectives(_createElementVNode("input", {
                        name: "ssn",
                        type: "text",
                        class: _normalizeClass(["flex-grow join-input-field", { 'border-red-600': _ctx.formElements.ssn.error }]),
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formElements.ssn.value) = $event)),
                        onChange: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.checkCprField && _ctx.checkCprField(...args))),
                        disabled: _ctx.formConfig.viewMode === 'VIEW' || _ctx.formConfig.systemPropertyConfig.ssn === 'view',
                        "data-cy": "input"
                      }, null, 42, _hoisted_20), [
                        [_vModelText, _ctx.formElements.ssn.value]
                      ])
                    ]),
                    (_ctx.formElements.ssn.error)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_21, _toDisplayString(_ctx.$t(_ctx.formElements.ssn.error)), 1))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.shouldBeVisible(_ctx.formConfig.systemPropertyConfig.salutation, _ctx.formElements.salutation))
                ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                    _createElementVNode("label", _hoisted_23, [
                      _createTextVNode(_toDisplayString(_ctx.$t('subscription.salutation')) + " ", 1),
                      _hoisted_24
                    ]),
                    _createElementVNode("div", _hoisted_25, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.salutations, (salutation) => {
                        return (_openBlock(), _createElementBlock("label", {
                          class: "inline-flex items-center",
                          key: salutation.name,
                          "data-cy": salutation.name
                        }, [
                          _withDirectives(_createElementVNode("input", {
                            type: "radio",
                            class: "form-radio",
                            name: "title",
                            value: salutation,
                            "onUpdate:modelValue": ($event: any) => ((_ctx.formElements.salutation.value) = $event),
                            disabled: _ctx.formConfig.viewMode === 'VIEW' || _ctx.formConfig.systemPropertyConfig.salutation === 'view',
                            onChange: _cache[6] || (_cache[6] = ($event: any) => (_ctx.checkInput('salutation'))),
                            "data-cy": "input"
                          }, null, 40, _hoisted_27), [
                            [_vModelRadio, _ctx.formElements.salutation.value]
                          ]),
                          _createElementVNode("span", _hoisted_28, _toDisplayString(_ctx.$t('general.salutations.' + salutation.name)), 1)
                        ], 8, _hoisted_26))
                      }), 128))
                    ]),
                    (_ctx.formElements.salutation.error)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_29, _toDisplayString(_ctx.$t(_ctx.formElements.salutation.error)), 1))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.showGender)
                ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                    _createElementVNode("label", _hoisted_31, [
                      _createTextVNode(_toDisplayString(_ctx.$t('subscription.gender')) + " ", 1),
                      _hoisted_32
                    ]),
                    _createElementVNode("div", _hoisted_33, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.genders, (gender) => {
                        return (_openBlock(), _createElementBlock("label", {
                          class: "inline-flex items-center mr-6",
                          key: gender.name,
                          "data-cy": gender.name
                        }, [
                          _withDirectives(_createElementVNode("input", {
                            type: "radio",
                            class: "form-radio",
                            name: "gender",
                            checked: gender.value === _ctx.formElements.gender.value,
                            value: gender.value,
                            disabled: _ctx.cprIsUsed || _ctx.formConfig.viewMode === 'VIEW' || _ctx.formConfig.systemPropertyConfig.gender === 'view',
                            "onUpdate:modelValue": ($event: any) => ((_ctx.formElements.gender.value) = $event),
                            onChange: _cache[7] || (_cache[7] = ($event: any) => (_ctx.checkInput('gender'))),
                            "data-cy": "input"
                          }, null, 40, _hoisted_35), [
                            [_vModelRadio, _ctx.formElements.gender.value]
                          ]),
                          _createElementVNode("span", _hoisted_36, _toDisplayString(_ctx.$t('general.' + gender.value)), 1)
                        ], 8, _hoisted_34))
                      }), 128))
                    ]),
                    (_ctx.formElements.gender.error)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_37, _toDisplayString(_ctx.$t(_ctx.formElements.gender.error)), 1))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.shouldBeVisible(_ctx.formConfig.systemPropertyConfig.birthday, _ctx.formElements.birthday))
                ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                    _createElementVNode("label", _hoisted_39, [
                      _createTextVNode(_toDisplayString(_ctx.$t('subscription.birthday')) + " ", 1),
                      (_ctx.formConfig.systemPropertyConfig.birthday === 'required')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_40, "*"))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_41, [
                      _withDirectives(_createElementVNode("input", {
                        name: "birthday",
                        type: "date",
                        class: _normalizeClass(["flex-grow join-input-field", { 'border-red-600': _ctx.formElements.birthday.error }]),
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.formElements.birthday.value) = $event)),
                        onChange: _cache[9] || (_cache[9] = ($event: any) => (_ctx.checkInput('birthday'))),
                        max: _ctx.getMinimumDateForCreationNewPerson(_ctx.formConfig.systemPropertyConfig),
                        disabled: _ctx.cprIsUsed || _ctx.formConfig.viewMode === 'VIEW' || _ctx.formConfig.systemPropertyConfig.birthday === 'view',
                        dir: _ctx.$store.state.currentLocale?.direction,
                        "data-cy": "input"
                      }, null, 42, _hoisted_42), [
                        [_vModelText, _ctx.formElements.birthday.value]
                      ])
                    ]),
                    (_ctx.formElements.birthday.error)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_43, _toDisplayString(_ctx.$t(_ctx.formElements.birthday.error)), 1))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.shouldBeVisible(_ctx.formConfig.systemPropertyConfig.preferredLanguage, _ctx.formElements.language))
                ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                    _createElementVNode("label", _hoisted_45, [
                      _createTextVNode(_toDisplayString(_ctx.$t('subscription.preferredLanguage')) + " ", 1),
                      (_ctx.formConfig.systemPropertyConfig.preferredLanguage === 'required')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_46, "*"))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_47, [
                      _withDirectives(_createElementVNode("select", {
                        name: "language",
                        disabled: _ctx.formConfig.viewMode === 'VIEW' || _ctx.formConfig.systemPropertyConfig.preferredLanguage === 'view',
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.formElements.language.value) = $event)),
                        class: "join-input-field",
                        "data-cy": "input",
                        onChange: _cache[11] || (_cache[11] = ($event: any) => (_ctx.checkInput('language')))
                      }, [
                        _createElementVNode("option", _hoisted_49, _toDisplayString(_ctx.$t('subscription.preferredLanguagePlaceholder')), 1),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.languages, (language) => {
                          return (_openBlock(), _createElementBlock("option", {
                            value: language.value,
                            key: language.name
                          }, _toDisplayString(_ctx.capitalizeFirstLetter(language.name)), 9, _hoisted_50))
                        }), 128))
                      ], 40, _hoisted_48), [
                        [_vModelSelect, _ctx.formElements.language.value]
                      ])
                    ]),
                    (_ctx.formElements.language.error)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_51, _toDisplayString(_ctx.$t(_ctx.formElements.language.error)), 1))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.shouldBeVisible(_ctx.formConfig.systemPropertyConfig.mobile, _ctx.formElements.phone))
                ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
                    _createElementVNode("label", _hoisted_53, [
                      _createTextVNode(_toDisplayString(_ctx.$t('subscription.phone')) + " ", 1),
                      (_ctx.formConfig.systemPropertyConfig.mobile === 'required')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_54, "*"))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_55, [
                      _createVNode(_component_vue_tel_input, _mergeProps({
                        ref: "phoneInput",
                        modelValue: _ctx.vueTelPhone,
                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.vueTelPhone) = $event))
                      }, _ctx.vueTelProps, {
                        disabled: _ctx.formConfig.viewMode === 'VIEW' || _ctx.formConfig.systemPropertyConfig.mobile === 'view',
                        styleClasses: "flex w-full",
                        onOnInput: _ctx.validatePhoneNumber,
                        onChange: _cache[13] || (_cache[13] = ($event: any) => (_ctx.checkInput('phone'))),
                        "data-cy": "input"
                      }), null, 16, ["modelValue", "disabled", "onOnInput"])
                    ]),
                    (_ctx.formElements.phone.error)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_56, _toDisplayString(_ctx.$t(_ctx.formElements.phone.error)), 1))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              (
            _ctx.formConfig.systemPropertyConfig.passport !== 'not-used' ||
            _ctx.formConfig.systemPropertyConfig.residentId !== 'not-used' ||
            _ctx.formConfig.systemPropertyConfig.nationalId !== 'not-used'
          )
                ? (_openBlock(), _createElementBlock("div", _hoisted_57, [
                    (_ctx.formConfig.mode === 'JOIN' || _ctx.formConfig.mode === 'LEAD')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_58, [
                          _createElementVNode("div", _hoisted_59, [
                            _createElementVNode("label", _hoisted_60, [
                              _createTextVNode(_toDisplayString(_ctx.$t('subscription.idType')) + " ", 1),
                              (_ctx.$store.state.config?.features.userIdRequired)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_61, "*"))
                                : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("label", _hoisted_62, [
                              _createTextVNode(_toDisplayString(_ctx.$t('subscription.number')) + " ", 1),
                              (_ctx.$store.state.config?.features.userIdRequired)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_63, "*"))
                                : _createCommentVNode("", true)
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_64, [
                            _withDirectives(_createElementVNode("select", {
                              name: "idType",
                              "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.formElements.idType.value) = $event)),
                              class: _normalizeClass(["bg-white text-gray-700 py-2 px-3 appearance-none border rounded-l focus:outline-none w-1/3", { 'border-red-600': _ctx.formElements.idType.error }]),
                              "data-cy": "id-type",
                              onChange: _cache[15] || (_cache[15] = ($event: any) => (_ctx.checkInput('idType')))
                            }, [
                              _createElementVNode("option", _hoisted_65, _toDisplayString(_ctx.$t('subscription.idTypePlaceholder')), 1),
                              (_ctx.formConfig.systemPropertyConfig.passport !== 'not-used')
                                ? (_openBlock(), _createElementBlock("option", _hoisted_66, _toDisplayString(_ctx.$t('subscription.passport')), 1))
                                : _createCommentVNode("", true),
                              (_ctx.formConfig.systemPropertyConfig.nationalId !== 'not-used')
                                ? (_openBlock(), _createElementBlock("option", _hoisted_67, _toDisplayString(_ctx.$t('subscription.nationalId')), 1))
                                : _createCommentVNode("", true),
                              (_ctx.formConfig.systemPropertyConfig.residentId !== 'not-used')
                                ? (_openBlock(), _createElementBlock("option", _hoisted_68, _toDisplayString(_ctx.$t('subscription.residentId')), 1))
                                : _createCommentVNode("", true)
                            ], 34), [
                              [_vModelSelect, _ctx.formElements.idType.value]
                            ]),
                            _withDirectives(_createElementVNode("input", {
                              name: "idNumber",
                              type: "text",
                              class: _normalizeClass(["bg-white text-gray-700 py-2 px-3 appearance-none border rounded-l focus:outline-none w-full ml-2", { 'border-red-600': _ctx.formElements.idNumber.error }]),
                              "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.formElements.idNumber.value) = $event)),
                              onChange: _cache[17] || (_cache[17] = ($event: any) => (_ctx.checkInput('idNumber'))),
                              "data-cy": "id-number"
                            }, null, 34), [
                              [_vModelText, _ctx.formElements.idNumber.value]
                            ])
                          ])
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_69, [
                          (_ctx.shouldBeVisible(_ctx.formConfig.systemPropertyConfig.nationalId, _ctx.formElements.nationalId))
                            ? (_openBlock(), _createElementBlock("div", _hoisted_70, [
                                _createElementVNode("label", _hoisted_71, _toDisplayString(_ctx.$t('subscription.nationalId')), 1),
                                _withDirectives(_createElementVNode("input", {
                                  name: "nationalId",
                                  type: "text",
                                  class: _normalizeClass(["flex-grow join-input-field", { 'border-red-600': _ctx.formElements.nationalId.error }]),
                                  "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.formElements.nationalId.value) = $event)),
                                  onChange: _cache[19] || (_cache[19] = ($event: any) => (_ctx.checkInput('nationalId'))),
                                  "data-cy": "input",
                                  disabled: _ctx.formConfig.viewMode === 'VIEW' || _ctx.formConfig.systemPropertyConfig.nationalId === 'view'
                                }, null, 42, _hoisted_72), [
                                  [_vModelText, _ctx.formElements.nationalId.value]
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          (_ctx.shouldBeVisible(_ctx.formConfig.systemPropertyConfig.residentId, _ctx.formElements.residentId))
                            ? (_openBlock(), _createElementBlock("div", _hoisted_73, [
                                _createElementVNode("label", _hoisted_74, _toDisplayString(_ctx.$t('subscription.residentId')), 1),
                                _withDirectives(_createElementVNode("input", {
                                  name: "residentId",
                                  type: "text",
                                  class: _normalizeClass(["flex-grow join-input-field", { 'border-red-600': _ctx.formElements.residentId.error }]),
                                  "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.formElements.residentId.value) = $event)),
                                  onChange: _cache[21] || (_cache[21] = ($event: any) => (_ctx.checkInput('residentId'))),
                                  "data-cy": "input",
                                  disabled: _ctx.formConfig.viewMode === 'VIEW' || _ctx.formConfig.systemPropertyConfig.residentId === 'view'
                                }, null, 42, _hoisted_75), [
                                  [_vModelText, _ctx.formElements.residentId.value]
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          (_ctx.shouldBeVisible(_ctx.formConfig.systemPropertyConfig.passport, _ctx.formElements.passport))
                            ? (_openBlock(), _createElementBlock("div", _hoisted_76, [
                                _createElementVNode("label", _hoisted_77, _toDisplayString(_ctx.$t('subscription.passport')), 1),
                                _withDirectives(_createElementVNode("input", {
                                  name: "passport",
                                  type: "text",
                                  class: _normalizeClass(["flex-grow join-input-field", { 'border-red-600': _ctx.formElements.passport.error }]),
                                  "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.formElements.passport.value) = $event)),
                                  onChange: _cache[23] || (_cache[23] = ($event: any) => (_ctx.checkInput('passport'))),
                                  "data-cy": "input",
                                  disabled: _ctx.formConfig.viewMode === 'VIEW' || _ctx.formConfig.systemPropertyConfig.passport === 'view'
                                }, null, 42, _hoisted_78), [
                                  [_vModelText, _ctx.formElements.passport.value]
                                ])
                              ]))
                            : _createCommentVNode("", true)
                        ]))
                  ]))
                : _createCommentVNode("", true),
              (_ctx.showPassportDetails())
                ? (_openBlock(), _createElementBlock("div", _hoisted_79, [
                    _createElementVNode("div", _hoisted_80, [
                      _createElementVNode("label", _hoisted_81, [
                        _createTextVNode(_toDisplayString(_ctx.$t('subscription.issuanceCountry')) + " ", 1),
                        _hoisted_82
                      ]),
                      _createElementVNode("label", _hoisted_83, [
                        _createTextVNode(_toDisplayString(_ctx.$t('subscription.expirationDate')) + " ", 1),
                        _hoisted_84
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_85, [
                      _withDirectives(_createElementVNode("select", {
                        name: "passportCountry",
                        "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.formElements.passportCountry.value) = $event)),
                        class: _normalizeClass(["bg-white text-gray-700 py-2 px-3 appearance-none border rounded-l focus:outline-none w-1/2", { 'border-red-600': _ctx.formElements.passportCountry.error }]),
                        "data-cy": "id-country",
                        onChange: _cache[25] || (_cache[25] = ($event: any) => (_ctx.checkInput('passportCountry'))),
                        disabled: _ctx.formConfig.viewMode === 'VIEW' || _ctx.formConfig.systemPropertyConfig.passport === 'view'
                      }, [
                        _createElementVNode("option", _hoisted_87, _toDisplayString(_ctx.$t('subscription.passportCountryPlaceholder')), 1),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.formElements.passportCountry.options, (country) => {
                          return (_openBlock(), _createElementBlock("option", {
                            key: country,
                            value: country.code
                          }, _toDisplayString(country.name), 9, _hoisted_88))
                        }), 128))
                      ], 42, _hoisted_86), [
                        [_vModelSelect, _ctx.formElements.passportCountry.value]
                      ]),
                      _withDirectives(_createElementVNode("input", {
                        name: "passportDate",
                        type: "date",
                        class: _normalizeClass(["bg-white text-gray-700 py-2 px-3 appearance-none border rounded-l focus:outline-none w-1/2", { 'border-red-600': _ctx.formElements.passportDate.error }]),
                        "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.formElements.passportDate.value) = $event)),
                        onChange: _cache[27] || (_cache[27] = ($event: any) => (_ctx.checkInput('passportDate'))),
                        "data-cy": "id-date",
                        disabled: _ctx.formConfig.viewMode === 'VIEW' || _ctx.formConfig.systemPropertyConfig.passport === 'view',
                        min: _ctx.getToday()
                      }, null, 42, _hoisted_89), [
                        [_vModelText, _ctx.formElements.passportDate.value]
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (
            _ctx.formElements.idType.error ||
            _ctx.formElements.idNumber.error ||
            _ctx.formElements.passportDate.error ||
            _ctx.formElements.passportCountry.error
          )
                ? (_openBlock(), _createElementBlock("p", _hoisted_90, _toDisplayString(_ctx.$t(
              _ctx.formElements.idType.error ||
                _ctx.formElements.idNumber.error ||
                _ctx.formElements.nationalId.error ||
                _ctx.formElements.residentId.error ||
                _ctx.formElements.passport.error ||
                _ctx.formElements.passportDate.error ||
                _ctx.formElements.passportCountry.error
            )), 1))
                : _createCommentVNode("", true)
            ], 512)
          ], 512), [
            [_vShow, _ctx.theContainerHasChildren('personal-info-section')]
          ]),
          _createElementVNode("div", _hoisted_91, [
            _withDirectives(_createElementVNode("h3", { class: "text-lg leading-6 font-medium text-gray-900 mt-2" }, _toDisplayString(_ctx.$t('subscription.addressSection')), 513), [
              [_vShow, _ctx.theContainerHasChildren('address-section')]
            ]),
            _createElementVNode("section", _hoisted_92, [
              (_ctx.shouldBeVisible(_ctx.formConfig.systemPropertyConfig.address1, _ctx.formElements.address1))
                ? (_openBlock(), _createElementBlock("div", _hoisted_93, [
                    _createElementVNode("label", _hoisted_94, [
                      _createTextVNode(_toDisplayString(_ctx.formConfig.systemPropertyConfig.address2 !== 'not-used' ? _ctx.$t('subscription.address1') : _ctx.$t('subscription.address')) + " ", 1),
                      (_ctx.formConfig.systemPropertyConfig.address1 === 'required')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_95, "*"))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_96, [
                      _withDirectives(_createElementVNode("input", {
                        name: "address1",
                        type: "text",
                        class: _normalizeClass(["flex-grow join-input-field", { 'border-red-600': _ctx.formElements.address1.error }]),
                        "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.formElements.address1.value) = $event)),
                        onChange: _cache[29] || (_cache[29] = ($event: any) => (_ctx.checkInput('address1'))),
                        onInput: _cache[30] || (_cache[30] = ($event: any) => (_ctx.checkAddressField('address1'))),
                        disabled: _ctx.formConfig.viewMode === 'VIEW' || _ctx.formConfig.systemPropertyConfig.address1 === 'view',
                        "data-cy": "input"
                      }, null, 42, _hoisted_97), [
                        [_vModelText, _ctx.formElements.address1.value]
                      ])
                    ]),
                    (_ctx.formElements.address1.error)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_98, _toDisplayString(_ctx.$t(_ctx.formElements.address1.error)), 1))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.shouldBeVisible(_ctx.formConfig.systemPropertyConfig.address2, _ctx.formElements.address2))
                ? (_openBlock(), _createElementBlock("div", _hoisted_99, [
                    _createElementVNode("label", _hoisted_100, [
                      _createTextVNode(_toDisplayString(_ctx.$t('subscription.address2')) + " ", 1),
                      (_ctx.formConfig.systemPropertyConfig.address2 === 'required')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_101, "*"))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_102, [
                      _withDirectives(_createElementVNode("input", {
                        name: "address2",
                        type: "text",
                        class: _normalizeClass(["flex-grow join-input-field", { 'border-red-600': _ctx.formElements.address2.error }]),
                        "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.formElements.address2.value) = $event)),
                        onChange: _cache[32] || (_cache[32] = ($event: any) => (_ctx.checkInput('address2'))),
                        onInput: _cache[33] || (_cache[33] = ($event: any) => (_ctx.checkAddressField('address2'))),
                        disabled: _ctx.formConfig.viewMode === 'VIEW' || _ctx.formConfig.systemPropertyConfig.address2 === 'view',
                        "data-cy": "input"
                      }, null, 42, _hoisted_103), [
                        [_vModelText, _ctx.formElements.address2.value]
                      ])
                    ]),
                    (_ctx.formElements.address2.error)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_104, _toDisplayString(_ctx.$t(_ctx.formElements.address2.error)), 1))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.shouldBeVisible(_ctx.formConfig.systemPropertyConfig.country, _ctx.formElements.country))
                ? (_openBlock(), _createElementBlock("div", _hoisted_105, [
                    _createElementVNode("label", _hoisted_106, [
                      _createTextVNode(_toDisplayString(_ctx.$t('subscription.country')) + " ", 1),
                      (_ctx.formConfig.systemPropertyConfig.country === 'required')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_107, "*"))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_108, [
                      _withDirectives(_createElementVNode("select", {
                        name: "country",
                        disabled: _ctx.formConfig.viewMode === 'VIEW' || _ctx.formConfig.systemPropertyConfig.country === 'view',
                        "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => ((_ctx.formElements.country.value) = $event)),
                        class: "join-input-field",
                        "data-cy": "input",
                        onChange: _cache[35] || (_cache[35] = ($event: any) => (_ctx.checkInput('country')))
                      }, [
                        _createElementVNode("option", _hoisted_110, _toDisplayString(_ctx.$t('subscription.countryPlaceholder')), 1),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.formElements.country.options, (country) => {
                          return (_openBlock(), _createElementBlock("option", {
                            value: country.code,
                            key: country
                          }, _toDisplayString(country.name), 9, _hoisted_111))
                        }), 128))
                      ], 40, _hoisted_109), [
                        [_vModelSelect, _ctx.formElements.country.value]
                      ])
                    ]),
                    (_ctx.formElements.country.error)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_112, _toDisplayString(_ctx.$t(_ctx.formElements.country.error)), 1))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.formElements.country.value && _ctx.shouldBeVisible(_ctx.formConfig.systemPropertyConfig.zip, _ctx.formElements.zipCode))
                ? (_openBlock(), _createElementBlock("div", _hoisted_113, [
                    _createElementVNode("label", _hoisted_114, [
                      _createTextVNode(_toDisplayString(_ctx.$t('subscription.zipCode')) + " ", 1),
                      (_ctx.formConfig.systemPropertyConfig.zip === 'required')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_115, "*"))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_116, [
                      _withDirectives(_createElementVNode("input", {
                        name: "zipCode",
                        type: "text",
                        class: _normalizeClass(["flex-grow join-input-field", { 'border-red-600': _ctx.formElements.zipCode.error }]),
                        "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => ((_ctx.formElements.zipCode.value) = $event)),
                        onChange: _cache[37] || (_cache[37] = ($event: any) => (_ctx.checkInput('zipCode'))),
                        disabled: _ctx.formConfig.viewMode === 'VIEW' || _ctx.formConfig.systemPropertyConfig.zip === 'view',
                        placeholder: _ctx.getZipCodeFormatForCountry(_ctx.formElements.country.value, _ctx.$t('subscription.zipCodePlaceHolder')),
                        "data-cy": "input"
                      }, null, 42, _hoisted_117), [
                        [_vModelText, _ctx.formElements.zipCode.value]
                      ])
                    ]),
                    (_ctx.formElements.zipCode.error)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_118, _toDisplayString(_ctx.$t(_ctx.formElements.zipCode.error)), 1))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.formElements.country.value && _ctx.shouldBeVisible(_ctx.formConfig.systemPropertyConfig.city, _ctx.formElements.city))
                ? (_openBlock(), _createElementBlock("div", _hoisted_119, [
                    _createElementVNode("label", _hoisted_120, [
                      _createTextVNode(_toDisplayString(_ctx.$t('subscription.city')) + " ", 1),
                      (_ctx.formConfig.systemPropertyConfig.city === 'required')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_121, "*"))
                        : _createCommentVNode("", true)
                    ]),
                    (_ctx.formElements.country.value === 'US')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_122, [
                          _withDirectives(_createElementVNode("input", {
                            name: "city",
                            type: "text",
                            class: _normalizeClass(["join-input-field", { 'border-red-600': _ctx.formElements.city.error }]),
                            "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => ((_ctx.formElements.city.value) = $event)),
                            disabled: _ctx.formConfig.viewMode === 'VIEW' || _ctx.formConfig.systemPropertyConfig.city === 'view',
                            onChange: _cache[39] || (_cache[39] = ($event: any) => (_ctx.checkInput('city'))),
                            "data-cy": "input"
                          }, null, 42, _hoisted_123), [
                            [_vModelText, _ctx.formElements.city.value]
                          ])
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_124, [
                          _withDirectives(_createElementVNode("select", {
                            name: "city",
                            "onUpdate:modelValue": _cache[40] || (_cache[40] = ($event: any) => ((_ctx.formElements.city.value) = $event)),
                            disabled: _ctx.formConfig.viewMode === 'VIEW' || _ctx.formConfig.systemPropertyConfig.city === 'view',
                            class: "join-input-field",
                            "data-cy": "input",
                            onChange: _cache[41] || (_cache[41] = ($event: any) => (_ctx.checkInput('city')))
                          }, [
                            _createElementVNode("option", _hoisted_126, _toDisplayString(_ctx.$t('subscription.cityPlaceholder')), 1),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.formElements.city.options, (city) => {
                              return (_openBlock(), _createElementBlock("option", {
                                value: city.original,
                                key: city.original
                              }, _toDisplayString(city.translated), 9, _hoisted_127))
                            }), 128))
                          ], 40, _hoisted_125), [
                            [_vModelSelect, _ctx.formElements.city.value]
                          ])
                        ])),
                    (_ctx.formElements.city.error)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_128, _toDisplayString(_ctx.$t(_ctx.formElements.city.error)), 1))
                      : _createCommentVNode("", true),
                    (_ctx.formElements.city.checking === true)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_129, [
                          _createVNode(_component_spinner, {
                            text: _ctx.$t('subscription.loadingCities')
                          }, null, 8, ["text"])
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.formElements.country.value && _ctx.shouldBeVisible(_ctx.formConfig.systemPropertyConfig.state, _ctx.formElements.state))
                ? (_openBlock(), _createElementBlock("div", _hoisted_130, [
                    _createElementVNode("label", _hoisted_131, [
                      _createTextVNode(_toDisplayString(_ctx.$t('subscription.state')) + " ", 1),
                      (_ctx.formConfig.systemPropertyConfig.state === 'required')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_132, "*"))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_133, [
                      _withDirectives(_createElementVNode("select", {
                        name: "state",
                        disabled: _ctx.formConfig.viewMode === 'VIEW' || _ctx.formConfig.systemPropertyConfig.state === 'view',
                        "onUpdate:modelValue": _cache[42] || (_cache[42] = ($event: any) => ((_ctx.formElements.state.value) = $event)),
                        class: "join-input-field",
                        "data-cy": "input",
                        onChange: _cache[43] || (_cache[43] = ($event: any) => (_ctx.checkInput('state')))
                      }, [
                        _createElementVNode("option", _hoisted_135, _toDisplayString(_ctx.$t('subscription.statePlaceholder')), 1),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.formElements.state.options, (state) => {
                          return (_openBlock(), _createElementBlock("option", {
                            value: state.code,
                            key: state
                          }, _toDisplayString(state.name), 9, _hoisted_136))
                        }), 128))
                      ], 40, _hoisted_134), [
                        [_vModelSelect, _ctx.formElements.state.value]
                      ])
                    ]),
                    (_ctx.formElements.state.error)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_137, _toDisplayString(_ctx.$t(_ctx.formElements.state.error)), 1))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true)
            ], 512),
            _withDirectives(_createElementVNode("h3", { class: "text-lg leading-6 font-medium text-gray-900 mt-2" }, _toDisplayString(_ctx.$t('subscription.contractSection')), 513), [
              [_vShow, _ctx.theContainerHasChildren('contract-section')]
            ]),
            (_ctx.formConfig.mode !== 'PROFILE')
              ? (_openBlock(), _createElementBlock("section", _hoisted_138, [
                  (_ctx.formConfig.systemPropertyConfig.htmlContract)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_139, [
                        _createElementVNode("label", _hoisted_140, _toDisplayString(_ctx.$t('subscription.contract')), 1),
                        _createElementVNode("div", _hoisted_141, [
                          _createVNode(_component_html_textarea, {
                            value: _ctx.formConfig.systemPropertyConfig.htmlContract,
                            class: "w-full border-2 max-h-96 p-2 overflow-y-auto",
                            "data-cy": "input"
                          }, null, 8, ["value"])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.formConfig.systemPropertyConfig.termsAndConditions)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_142, [
                        _createElementVNode("div", _hoisted_143, [
                          _createElementVNode("label", _hoisted_144, [
                            _withDirectives(_createElementVNode("input", {
                              name: "terms",
                              type: "checkbox",
                              "onUpdate:modelValue": _cache[44] || (_cache[44] = ($event: any) => ((_ctx.formElements.terms.value) = $event)),
                              class: _normalizeClass({ 'border-red-600': _ctx.formElements.terms.error }),
                              onChange: _cache[45] || (_cache[45] = ($event: any) => (_ctx.checkInput('terms'))),
                              "data-cy": "input"
                            }, null, 34), [
                              [_vModelCheckbox, _ctx.formElements.terms.value]
                            ]),
                            _createElementVNode("span", _hoisted_145, [
                              _createTextVNode(_toDisplayString(_ctx.$t('subscription.iAccept')) + " ", 1),
                              _createElementVNode("a", {
                                class: "text-primary-500",
                                href: _ctx.formConfig.systemPropertyConfig.termsAndConditions,
                                target: "_blank",
                                "data-cy": "link"
                              }, _toDisplayString(_ctx.$t('subscription.termsAndConditions')), 9, _hoisted_146),
                              _hoisted_147
                            ])
                          ])
                        ]),
                        (_ctx.formElements.terms.error)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_148, _toDisplayString(_ctx.$t(_ctx.formElements.terms.error)), 1))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.formConfig.systemPropertyConfig.checkbox1)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_149, [
                        _createElementVNode("div", _hoisted_150, [
                          _createElementVNode("label", _hoisted_151, [
                            _withDirectives(_createElementVNode("input", {
                              name: "checkbox1",
                              type: "checkbox",
                              "onUpdate:modelValue": _cache[46] || (_cache[46] = ($event: any) => ((_ctx.formElements.checkbox1.value) = $event)),
                              class: _normalizeClass(["flex", { 'border-red-600': _ctx.formElements.checkbox1.error }]),
                              onChange: _cache[47] || (_cache[47] = ($event: any) => (_ctx.checkInput('checkbox1'))),
                              "data-cy": "input"
                            }, null, 34), [
                              [_vModelCheckbox, _ctx.formElements.checkbox1.value]
                            ]),
                            _createElementVNode("span", _hoisted_152, [
                              _createVNode(_component_html_textarea, {
                                value: _ctx.$t(_ctx.formConfig.systemPropertyConfig.checkbox1),
                                "data-cy": "checkbox-text-1",
                                class: "w-full"
                              }, null, 8, ["value"])
                            ]),
                            _hoisted_153
                          ])
                        ]),
                        (_ctx.formElements.checkbox1.error)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_154, _toDisplayString(_ctx.$t(_ctx.formElements.checkbox1.error)), 1))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.formConfig.systemPropertyConfig.checkbox2)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_155, [
                        _createElementVNode("div", _hoisted_156, [
                          _createElementVNode("label", _hoisted_157, [
                            _withDirectives(_createElementVNode("input", {
                              name: "checkbox2",
                              type: "checkbox",
                              "onUpdate:modelValue": _cache[48] || (_cache[48] = ($event: any) => ((_ctx.formElements.checkbox2.value) = $event)),
                              class: _normalizeClass(["flex", { 'border-red-600': _ctx.formElements.checkbox2.error }]),
                              onChange: _cache[49] || (_cache[49] = ($event: any) => (_ctx.checkInput('checkbox2'))),
                              "data-cy": "input"
                            }, null, 34), [
                              [_vModelCheckbox, _ctx.formElements.checkbox2.value]
                            ]),
                            _createElementVNode("span", _hoisted_158, [
                              _createVNode(_component_html_textarea, {
                                value: _ctx.$t(_ctx.formConfig.systemPropertyConfig.checkbox2),
                                "data-cy": "checkbox-text-2",
                                class: "w-full"
                              }, null, 8, ["value"])
                            ]),
                            _hoisted_159
                          ])
                        ]),
                        (_ctx.formElements.checkbox2.error)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_160, _toDisplayString(_ctx.$t(_ctx.formElements.checkbox2.error)), 1))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.formConfig.systemPropertyConfig.checkbox3)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_161, [
                        _createElementVNode("div", _hoisted_162, [
                          _createElementVNode("label", _hoisted_163, [
                            _withDirectives(_createElementVNode("input", {
                              name: "checkbox3",
                              type: "checkbox",
                              "onUpdate:modelValue": _cache[50] || (_cache[50] = ($event: any) => ((_ctx.formElements.checkbox3.value) = $event)),
                              class: _normalizeClass(["flex", { 'border-red-600': _ctx.formElements.checkbox3.error }]),
                              onChange: _cache[51] || (_cache[51] = ($event: any) => (_ctx.checkInput('checkbox3'))),
                              "data-cy": "input"
                            }, null, 34), [
                              [_vModelCheckbox, _ctx.formElements.checkbox3.value]
                            ]),
                            _createElementVNode("span", _hoisted_164, [
                              _createVNode(_component_html_textarea, {
                                value: _ctx.$t(_ctx.formConfig.systemPropertyConfig.checkbox3),
                                "data-cy": "checkbox-text-3",
                                class: "w-full"
                              }, null, 8, ["value"])
                            ]),
                            _hoisted_165
                          ])
                        ]),
                        (_ctx.formElements.checkbox3.error)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_166, _toDisplayString(_ctx.$t(_ctx.formElements.checkbox3.error)), 1))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true)
                ], 512))
              : _createCommentVNode("", true),
            _createElementVNode("section", _hoisted_167, [
              (_ctx.formConfig.systemPropertyConfig.allowEmailNewsletters)
                ? (_openBlock(), _createElementBlock("div", _hoisted_168, [
                    _createElementVNode("div", _hoisted_169, [
                      _createElementVNode("label", _hoisted_170, [
                        _withDirectives(_createElementVNode("input", {
                          name: "allowEmailNewsletters",
                          type: "checkbox",
                          "onUpdate:modelValue": _cache[52] || (_cache[52] = ($event: any) => ((_ctx.formElements.allowEmailNewsletters.value) = $event)),
                          class: _normalizeClass({ 'border-red-600': _ctx.formElements.allowEmailNewsletters.error }),
                          "data-cy": "input",
                          disabled: _ctx.formConfig.viewMode === 'VIEW'
                        }, null, 10, _hoisted_171), [
                          [_vModelCheckbox, _ctx.formElements.allowEmailNewsletters.value]
                        ]),
                        _createElementVNode("span", _hoisted_172, _toDisplayString(_ctx.$t('subscription.allowEmailNewsletters')), 1)
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.formConfig.systemPropertyConfig.allowThirdPartyOffers)
                ? (_openBlock(), _createElementBlock("div", _hoisted_173, [
                    _createElementVNode("div", _hoisted_174, [
                      _createElementVNode("label", _hoisted_175, [
                        _withDirectives(_createElementVNode("input", {
                          name: "allowThirdPartyOffers",
                          type: "checkbox",
                          "onUpdate:modelValue": _cache[53] || (_cache[53] = ($event: any) => ((_ctx.formElements.allowThirdPartyOffers.value) = $event)),
                          class: _normalizeClass({ 'border-red-600': _ctx.formElements.allowThirdPartyOffers.error }),
                          "data-cy": "input",
                          disabled: _ctx.formConfig.viewMode === 'VIEW'
                        }, null, 10, _hoisted_176), [
                          [_vModelCheckbox, _ctx.formElements.allowThirdPartyOffers.value]
                        ]),
                        _createElementVNode("span", _hoisted_177, _toDisplayString(_ctx.$t('subscription.allowThirdPartyOffers')), 1)
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.$store.state.config?.braze?.url && _ctx.$store.state.config?.braze?.authCode && _ctx.formConfig.mode === 'PROFILE')
                ? (_openBlock(), _createElementBlock("div", _hoisted_178, [
                    _createElementVNode("div", _hoisted_179, [
                      _createElementVNode("button", {
                        onClick: _cache[54] || (_cache[54] = ($event: any) => (_ctx.redirectToPreferenceCenter())),
                        disabled: _ctx.loadingPreferenceCenter,
                        class: "flex btn-positive items-center justify-center",
                        "data-cy": "braze-button"
                      }, [
                        _createElementVNode("div", _hoisted_181, _toDisplayString(_ctx.$t('profile.braze')), 1)
                      ], 8, _hoisted_180)
                    ]),
                    (_ctx.brazeError)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_182, [
                          _createVNode(_component_error_display, {
                            "error-model": _ctx.brazeError,
                            "data-cy": "braze-error"
                          }, null, 8, ["error-model"])
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true)
            ], 512)
          ])
        ], 2))
      : _createCommentVNode("", true)
}